export interface FontList {
  axisName: true;
  // PC端轴名称字号为12
  axisLabel: true;
  legendLabel: true;
  tooltipLabel: true;
  axisPointerLabel: true;
  seriesLabel: true;
  titleLabel: true;
}
type FontType = keyof FontList;
export const FONT_SIZE_LIST = {
  // PC端轴名称字号为12
  axisName: 12,
  // PC端轴名称字号为12
  axisLabel: 12,
  legendLabel: 12,
  tooltipLabel: 12,
  axisPointerLabel: 12,
  seriesLabel: 12,
  titleLabel: 18
};

const FONT_OPACITY_LIST = {
  // PC端轴名称文本颜色
  axisName: 0.65,
  axisLabel: 0.65
};

export const FONT_LINEHEIGHT_LIST = {
  // PC端轴名称文本行高
  axisName: 12
};

export function getFontColor(labelType: FontType, themeName: 'dark' | 'light') {
  const color = themeName === 'light' ? 0 : 255;
  return `rgba(${color}, ${color}, ${color}, ${FONT_OPACITY_LIST[labelType]})`;
}
export const FONT_WEIGHT_LIST = {
  regular: 400,
  semibold: 600
};
